<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex'

const props = defineProps({
   violation_penalty_matrix: {
    type: Array,
    required: true
   } 
});

const store = useStore();

const loading = computed(() => store.state.globals.loading);
</script>

<template>
<b-overlay :show="loading">
    <div class="m-3">
        <table class="table table-bordered table-sm table-light m-0">
            <tbody v-if="!props.violation_penalty_matrix.length">
                <tr>
                    <th colspan="2" class="text-center">Violation Penalty Matrix</th>
                </tr>
                <tr>
                    <td colspan="2">n/a</td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <th colspan="2" class="text-center">Violation Penalty Matrix</th>
                </tr>
                <tr v-for="(matrix, index) in props.violation_penalty_matrix" :key="index">
                    <td>{{ matrix.name ? matrix.name : 'n/a' }}</td>
                    <td>{{ matrix.penalty_fee ? matrix.penalty_fee : 'n/a' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</b-overlay>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
th, td {
    background-color: #fff;
}
td{
  padding: 5px;
  text-align: center;
}
</style>
